(() => {
  const currency = (code) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
    style: 'currency', currency: code || 'SAR', minimumFractionDigits: 2, maximumFractionDigits: 2
  });

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  const formatTotal = (cents, code) => currency(code).format(cents / 100);

  document.addEventListener('DOMContentLoaded', () => {
    const grid = document.querySelector('[data-workshops-grid]');
    if (!grid) return;

    [...grid.querySelectorAll('[data-workshop-card]')]
      .sort((a, b) => Number(a.dataset.sortOrder || 9999) - Number(b.dataset.sortOrder || 9999))
      .forEach((card) => grid.append(card));

    const empty = document.querySelector('[data-workshops-empty]');
    if (empty) empty.hidden = grid.querySelectorAll('[data-workshop-card]').length !== 0;

    grid.querySelectorAll('[data-workshop-purchase]').forEach((purchase) => {
      const input = purchase.querySelector('input[name="quantity"]');
      const total = purchase.querySelector('[data-workshop-total]');
      const decrease = purchase.querySelector('[data-workshop-decrease]');
      const increase = purchase.querySelector('[data-workshop-increase]');
      if (!input || !total) return;

      const min = Number(input.min || 1);
      const max = Number(input.max || min);
      const cents = Number(purchase.dataset.priceCents || 0);
      const code = purchase.dataset.currency || 'SAR';

      const refresh = () => {
        const normalized = clamp(Number.parseInt(input.value, 10) || min, min, max);
        input.value = String(normalized);
        total.textContent = formatTotal(cents * normalized, code);
        if (decrease) decrease.disabled = normalized <= min;
        if (increase) increase.disabled = normalized >= max;
      };

      input.addEventListener('change', refresh);
      input.addEventListener('input', refresh);
      decrease?.addEventListener('click', () => { input.value = String((Number(input.value) || min) - 1); refresh(); input.focus(); });
      increase?.addEventListener('click', () => { input.value = String((Number(input.value) || min) + 1); refresh(); input.focus(); });
      refresh();


    });
  });
})();
